// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Maps',
  subtitle: 'View customer and company locations on the map',
  allLocations: 'All Locations',
  customers: 'Customers',
  companies: 'Companies',
  noLocations: 'No location information found',
  noLocationsDesc: 'No location data to display on the map.',
  fetchError: 'Location data could not be retrieved',
  loginRequired: 'Please login to view this page',
  connectionError: 'Could not connect to server',
  standardMap: 'Standard Map',
  standardMapDesc: 'Standard map view with markers',
  clusteredMap: 'Clustered Map',
  clusteredMapDesc: 'Map with clustered markers',
  heatmapMap: 'Heatmap',
  heatmapMapDesc: 'Heat density visualization',
  territoryMap: 'Territory Map',
  territoryMapDesc: 'Territory boundaries',
  networkMap: 'Network Map',
  networkMapDesc: 'Network connections',
  turkeyMap: 'Turkey Map',
  turkeyMapDesc: 'Turkey province map',
  defaultView: 'Default View',
  clearProvinceSelection: 'Clear Province Selection',
  companyLocationsShown: 'companies shown',
  mapLegend: 'Red: Has companies, Gray: No companies',
  selectedProvince: 'Selected',
  provinceDistribution: 'Province Distribution',
  provinceDistributionDesc: 'Companies by province',
  noCompaniesWithProvince: 'No companies with province information',
  selectProvinceWhenAdding: 'Select province when adding companies',
  companyLocations: 'Company Locations',
  noCompaniesWithLocation: 'No Companies with Location',
  noCompaniesWithLocationDesc: 'No companies have location information. Add location data to companies to see them on the map.',
  addLocationToCompanies: 'Add Location to Companies',
  selected: 'Selected'
};
